// frontend/src/ReleaseNotes/components/ReleaseNotesPublicFilters.tsx
import React, { useMemo } from "react";
import { Box, Button, Group, MultiSelect, Stack, Text, Title } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import {
  clearReleaseNotesAllFiltersInRedux,
  setReleaseNotesSelectedImpactsInRedux,
  setReleaseNotesSelectedModulesInRedux,
  setReleaseNotesSelectedTypesInRedux,
  // If you prefer toggle-per-item instead of set arrays, you can use these instead:
  // toggleReleaseNotesSelectedImpactInRedux,
  // toggleReleaseNotesSelectedModuleInRedux,
  // toggleReleaseNotesSelectedTypeInRedux,
  selectReleaseNotesSelectedImpacts,
  selectReleaseNotesSelectedModules,
  selectReleaseNotesSelectedTypes,
} from "../releaseNotesPublicSlice";
import { IModule, IReleaseType, IImpact } from "@multiconsult-group/multiplacer-core";
import {
  RELEASE_IMPACT_OPTIONS,
  RELEASE_MODULE_OPTIONS,
  RELEASE_TYPE_OPTIONS,
} from "../releaseNotesUiSpecs";

type Props = {
  title?: string;
};

export const ReleaseNotesPublicFilters: React.FC = () => {
  const dispatch = useAppDispatch();

  const selectedModules = useAppSelector(selectReleaseNotesSelectedModules);
  const selectedTypes = useAppSelector(selectReleaseNotesSelectedTypes);
  const selectedImpacts = useAppSelector(selectReleaseNotesSelectedImpacts);

  const moduleData = useMemo(
    () => RELEASE_MODULE_OPTIONS.map((o) => ({ value: o.value, label: o.label })),
    []
  );

  const typeData = useMemo(
    () => RELEASE_TYPE_OPTIONS.map((o) => ({ value: o.value, label: o.label })),
    []
  );

  const impactData = useMemo(
    () => RELEASE_IMPACT_OPTIONS.map((o) => ({ value: o.value, label: o.label })),
    []
  );

  const hasAnyFilter =
    selectedModules.length > 0 || selectedTypes.length > 0 || selectedImpacts.length > 0;

  return (
    <Box>
      <Stack gap="sm">
        <Group justify="space-between" align="flex-end">
          <Stack gap={2}>
            <Text size="sm" c="dimmed">
              Filtrer publiserte endringer etter modul, type og påvirkning.
            </Text>
          </Stack>

          <Button
            variant="light"
            disabled={!hasAnyFilter}
            onClick={() => dispatch(clearReleaseNotesAllFiltersInRedux())}
          >
            Nullstill filtre
          </Button>
        </Group>

        <Group align="flex-start" grow>
          <MultiSelect
            label="Modul"
            placeholder="Velg én eller flere"
            data={moduleData}
            value={selectedModules}
            clearable
            searchable
            nothingFoundMessage="Ingen treff"
            onChange={(values) =>
              dispatch(setReleaseNotesSelectedModulesInRedux(values as IModule[]))
            }
          />

          <MultiSelect
            label="Type"
            placeholder="Velg én eller flere"
            data={typeData}
            value={selectedTypes}
            clearable
            searchable
            nothingFoundMessage="Ingen treff"
            onChange={(values) =>
              dispatch(setReleaseNotesSelectedTypesInRedux(values as IReleaseType[]))
            }
          />

          <MultiSelect
            label="Påvirkning"
            placeholder="Velg én eller flere"
            data={impactData}
            value={selectedImpacts}
            clearable
            searchable
            nothingFoundMessage="Ingen treff"
            onChange={(values) =>
              dispatch(setReleaseNotesSelectedImpactsInRedux(values as IImpact[]))
            }
          />
        </Group>
      </Stack>
    </Box>
  );
};
